import { IActivityAction } from '@models/actions/IBaseAction';
import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IRequiredValidation } from '@models/actions/IRequiredValidation';
import { IActivityBatchEditingProps } from './IActivityBatchEditingProps';
import { ActivityBatchEditingModal } from './ActivityBatchEditingModal';

export const ActivityBatchEditingExecutor = createActivityModalExecutor<IActivityBatchEditingProps>({
    modal: ActivityBatchEditingModal,
    defaultModalSize: 'xl',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => {
        const act = action as IActivityAction;
        return {
            displayName: action.displayName,
            actionKey: action.key ?? '',
            docFlow: act?.flowName,
            actId: getActivityIdFromCompositeId(objId),
            docId: act.docId,
            attachFiles: action.options?.attachFiles == true,
            attachRequired: action.options?.attachRequired == true,
            attachRequiredValidation: action.options?.attachRequiredValidation as IRequiredValidation[],
            addMailReminders: action.options?.addMailReminders == true,
            virtualFields: action.options?.virtualFields as string[],
            showCurrentValues: action.options?.showCurrentValues ?? true,
            onlyEditValues: action.options?.onlyEditValues ?? false,
            okButtonText,
            cancelButtonText,
            modalSize,
            completeHandler,
        };
    },
});
